var map = {
	"./1.jpg": "ff79",
	"./10.jpg": "08e1",
	"./2.jpg": "af14",
	"./3.jpg": "7fb3",
	"./4.jpg": "f869",
	"./5.jpg": "5256",
	"./6.jpg": "64d3",
	"./7.jpg": "d207",
	"./8.jpg": "f938",
	"./9.jpg": "f365",
	"./poll.jpg": "1f4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47f6";